var React = require('react');

function V2SmallPhone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.21923 0C4.6781 0 5.07808 0.312297 5.18937 0.757464L5.82487 3.29948C5.92942 3.71768 5.75422 4.15581 5.39014 4.38661L4.08721 5.21256L4.23727 5.54236C5.51724 8.25413 7.70734 10.452 10.4135 11.7418L10.7885 11.9133L11.6135 10.6104C11.8442 10.246 12.2825 10.0706 12.7009 10.1752L15.2425 10.8106C15.6877 10.9219 16 11.3219 16 11.7808V15C16 15 16 16 15.0006 15.9681C7.05349 15.4606 0.542382 8.95002 0.0321939 1.00459C4.81308e-06 0 1 0 1 0H4.21923Z"}));
}

V2SmallPhone.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"current","stroke":"current"};

module.exports = V2SmallPhone;

V2SmallPhone.default = V2SmallPhone;
